import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import Transition from 'react-transition-group/Transition';
import { SpinnerIcon } from "../Icon";
import styles from './Spinner.module.scss';
const Spinner = (_a) => {
    var { isRendered, containerClassName, svgClassName, testId } = _a, rest = __rest(_a, ["isRendered", "containerClassName", "svgClassName", "testId"]);
    return (React.createElement(Transition, { in: isRendered, timeout: { enter: 0, exit: 300 }, mountOnEnter: true, unmountOnExit: true }, (isVisible) => (React.createElement("div", Object.assign({ className: cn(styles.container, isVisible && styles[isVisible], containerClassName), "data-testid": testId }, rest),
        React.createElement(SpinnerIcon, { className: cn(styles.icon, svgClassName) })))));
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map